import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

const AnswerOptions = ({
  index,
  answerOptions,
  addMoreOption,
  updateOptionValue,
  isBulkAdd,
  handleIsBulkAdd,
  bulkAddText,
  handleBulkText,
  handleSplitAnswers,
  isLocked = false,
}) => {
  return (
    <div className="answer-options mt-2">
      {!isBulkAdd ? (
        <Button
          className="bulk-add fw-bold fs-12 px-0 mb-3"
          link
          onClick={() => handleIsBulkAdd()}
          disabled={isLocked}
        >
          + Bulk Add
        </Button>
      ) : (
        <div className="my-3">
          <div className="fs-14 flex-fill">All answer option</div>
          <InputTextarea
            autoResize
            value={bulkAddText}
            onChange={(e) => handleBulkText(e.target.value)}
            rows={3}
            name="buld-add-textarea"
            className="w-100 inputField fs-14"
          />
          <div className="d-flex align-items-center justify-content-between">
            <small className="textarea-bottom-text fs-12">
              (Please enter or paste all answer options separated by commas.)
            </small>
            <Button
              className="fw-bold bulk-add fs-16 p-0"
              disabled={bulkAddText === "" || isLocked}
              link
              onClick={handleSplitAnswers}
            >
              Split answers
            </Button>
          </div>

          <Button
            className="bulk-close fw-bold fs-12 px-0"
            link
            onClick={() => handleIsBulkAdd()}
            disabled={isLocked}
          >
            - Close
          </Button>
        </div>
      )}

      <div className="row input-options">
        {answerOptions.length > 0
          ? answerOptions.map((answerOption, index) => (
              <div className="col-md-4 col-6 mb-2" key={index}>
                <InputText
                  id={`option-${index + 1}`}
                  className={`w-100 inputField ${answerOption?.isError ? "error-input" : ""}`}
                  autoComplete="off"
                  value={answerOption.value || ""}
                  placeholder={`${answerOption.label} ${answerOption.isOptional ? " (Optional)" : ""}`}
                  name={`${answerOption.label}`}
                  onChange={(e) => updateOptionValue(index, e.target.value)}
                />
                {answerOption?.isError ? (
                  <div className="text-start fs-14 text-danger">
                    {answerOption?.errorMsg}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ))
          : ""}
      </div>
      <Button
        className="bulk-add fs-16 p-0"
        link
        onClick={addMoreOption}
        disabled={isLocked}
      >
        + Add More Answer Options
      </Button>
    </div>
  );
};

export default AnswerOptions;
